<template>
  <div class="pay">
    <van-nav-bar fixed title="订单结算台" left-text="返回" left-arrow @click-left="goBack" />
    <div class="address">
      <div class="left-icon"><van-icon name="logistics" /></div>
      <div class="info" @click="goEditAddress">
        <div class="info-content" v-if="defaultAddress.name"><span class="name">{{ defaultAddress.name }}</span><span class="mobile">{{ defaultAddress.phone }}</span></div>
        <div v-else> 请选择配送地址 </div>
        <div class="info-address" v-if="defaultAddress.region">{{ defaultAddress.region.province }} {{ defaultAddress.region.city }} {{ defaultAddress.region.region }} {{ defaultAddress.detail }}</div>
      </div>
      <div class="right-icon"><van-icon name="arrow" /></div>
    </div>
    <div class="pay-list">
      <div class="list">
        <div class="goods-item" v-for="(item, index) in goodsList" :key="index + 'a'">
          <div class="left"><img :src="item.goods_image" alt=""></div>
          <div class="right"><p class="tit text-ellipsis-2">{{ item.goods_name }}</p><p class="spec-text" v-if="item.spec_text">{{ item.spec_text }}</p><p class="info"><span class="count">x{{ item.total_num }}</span><span class="price">¥{{ item.goods_price_min }}</span></p></div>
        </div>
      </div>
      <div class="flow-num-box"><span>共 {{ totalNum }} 件商品，合计：</span><span class="money">￥{{ totalPrice }}</span></div>
      <div class="pay-detail">
        <div class="pay-cell"><span>订单总金额：</span><span class="red">￥{{ totalPrice }}</span></div>
        <div class="pay-cell"><span>优惠券：</span><span>无优惠券可用</span></div>
      </div>
        <!-- 支付方式 -->
        <div class="pay-way">
          <div class="tit">支付方式</div>
          <!-- 微信支付 - 移除 disabled 和 unavailable-tag -->
          <div class="pay-cell" v-if="wechatEnabled" :class="{ selected: paymentMethod === 'wechat' }" @click="paymentMethod = 'wechat'">
            <span class="method-left">
              <span class="method-icon wechat">微</span>
              <span>微信支付</span>
            </span>
            <van-icon name="checked" size="18" :color="paymentMethod === 'wechat' ? '#07c160' : '#c8c9cc'" />
          </div>
          <!-- 支付宝支付 -->
          <div class="pay-cell" v-if="alipayEnabled" :class="{ selected: paymentMethod === 'alipay' }" @click="paymentMethod = 'alipay'">
            <span class="method-left">
              <span class="method-icon alipay">支</span>
              <span>支付宝支付</span>
            </span>
            <van-icon name="checked" size="18" :color="paymentMethod === 'alipay' ? '#1677ff' : '#c8c9cc'" />
          </div>
          <!-- 余额支付 -->
          <div class="pay-cell" v-if="balanceEnabled" :class="{ selected: paymentMethod === 'balance' }" @click="paymentMethod = 'balance'">
            <span class="method-left">
              <span class="method-icon balance">余</span>
              <span>余额支付</span>
              <span class="balance-tip" :class="{ 'insufficient': !balanceEnough }">（可用 ¥{{ Number(userBalance).toFixed(2) }}{{ !balanceEnough ? '，余额不足' : '' }}）</span>
            </span>
            <van-icon name="checked" size="18" :color="paymentMethod === 'balance' ? '#ffb400' : '#c8c9cc'" />
          </div>
          <div class="pay-none-tip" v-if="!wechatEnabled && !alipayEnabled && !balanceEnabled">当前商城暂未开通任何支付方式，请联系客服。</div>
        </div>
      <div class="buytips"><textarea v-model="remark" maxlength="50" placeholder="订单备注（选填，最多50个字）"></textarea></div>
    </div>
    <div class="footer-fixed"><div class="left">应付总额：<span>￥{{ totalPrice }}</span></div><span class="tipsbtn" :class="{ disabled: paying || paid }" @click="submitOrder">{{ paying || paid ? '支付中...' : '提交订单' }}</span></div>

    <!-- 微信 Native 扫码支付弹窗 -->
    <div class="qr-mask" v-if="qrVisible" @click="closeQr">
      <div class="qr-box" @click.stop>
        <div class="qr-title">微信扫码支付</div>
        <img class="qr-img" v-if="qrCodeDataUrl" :src="qrCodeDataUrl" alt="支付二维码" />
        <div class="qr-tip">请使用微信「扫一扫」完成支付</div>
        <div class="qr-amount">￥{{ totalPrice }}</div>
        <span class="qr-close" @click="closeQr">暂不支付</span>
      </div>
    </div>
  </div>
</template>

<script>
import { confirmOrderInfoApi, submitOrderApi, payOrderApi, getPaymentResultApi, getPaySettingsApi } from '@/api/pay'
import { getUserInfoDetail } from '@/api/user'
import { Toast } from 'vant'
import QRCode from 'qrcode'
export default {
  name: 'Pay',
  data () {
    return {
      detail: {},
      goodsList: [],
      remark: '',
      // 选中的支付方式：wechat 微信支付 / alipay 支付宝支付 / balance 余额支付
      paymentMethod: 'wechat',
      // 支付方式开关（后台系统设置控制）
      paySettings: {
        payment_wechat_enabled: 1,
        payment_alipay_enabled: 1,
        payment_balance_enabled: 1
      },
      // 当前账户可用余额
      userBalance: 0,
      // 提交/支付中
      paying: false,
      // 已支付成功（等待跳转期间禁用提交按钮，防止重复下单）
      paid: false,
      // 微信 JSAPI
      isWechat: false,
      openid: '',
      // 微信 Native 扫码支付
      qrVisible: false,
      qrCodeDataUrl: '',
      payPollTimer: null
    }
  },
  computed: {
    totalNum () { return this.detail.order ? this.detail.order.orderTotalNum : 0 },
    totalPrice () { return this.detail.order ? this.detail.order.orderTotalPrice : 0 },
    defaultAddress () { const list = this.$store.state.address.receiveAddressList; return list.find(item => item.is_default) || list[0] || {} },
    wechatEnabled () { return this.paySettings.payment_wechat_enabled !== 0 },
    alipayEnabled () { return this.paySettings.payment_alipay_enabled !== 0 },
    balanceEnabled () { return this.paySettings.payment_balance_enabled !== 0 },
    balanceEnough () { return this.userBalance >= this.totalPrice }
  },
  created () {
    this.isWechat = /MicroMessenger/i.test(navigator.userAgent)
    // openid 优先取 OAuth 回跳参数，其次取本地缓存（避免已授权用户每次下单都重复跳授权）
    this.openid = this.$route.query.openid || window.localStorage.getItem('wechat_openid') || ''
    if (this.$route.query.openid) {
      window.localStorage.setItem('wechat_openid', this.$route.query.openid)
    }
    if (this.$store.state.address.receiveAddressList.length === 0) { this.$store.dispatch('address/getReceivedAddressList') }
    this.loadPaySettings()
    this.loadUserBalance()
    // OAuth 授权成功回跳（auto_pay=1 且带 openid/orderId）→ 用已创建的订单直接拉起微信收银台，不再重复提交订单
    if (this.$route.query.auto_pay === '1' && this.$route.query.openid && this.$route.query.orderId) {
      this.paying = true
      this.$nextTick(() => this.doPay({ orderId: this.$route.query.orderId }))
      return
    }
    // 授权失败回跳：展示具体原因
    const oauthErr = this.$route.query.oauth_error || ''
    if (oauthErr) {
      const msgs = {
        wecom: '微信支付配置错误：当前 WECHAT_APP_ID 是企业微信 CorpID（ww 开头），JSAPI 支付需使用公众号/服务号 AppID（wx 开头）。请到 mp.weixin.qq.com 获取正确的 AppID 后更新 server/payment_config.php',
        secret: '微信支付配置错误：未配置 WECHAT_APP_SECRET，无法获取用户 openid。请到 mp.weixin.qq.com 获取 AppSecret 后填入 server/payment_config.php',
        '1': '微信授权失败，请确认公众号已配置网页授权域名（www.3v3v.cn）后再试'
      }
      const errDetail = this.$route.query.errmsg || ''
      const tip = msgs[oauthErr] || (errDetail ? '微信授权失败：' + errDetail : '微信授权失败，请重试')
      Toast(tip)
      return
    }
    this.getConfirmInfo()
  },
  beforeDestroy () { this.stopPayPolling() },
  methods: {
    goBack () {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/home')
      }
    },
    goEditAddress () { this.$router.push('/address') },
    // 读取支付方式开关（后台系统设置），并确保当前选中的方式可用
    async loadPaySettings () {
      try {
        const { data } = await getPaySettingsApi()
        if (data) {
          this.paySettings = data
          // 若当前选中的支付方式未开启，自动切换到已开启的方式（微信 → 支付宝 → 余额）
          if (this.paymentMethod === 'wechat' && !this.wechatEnabled && this.alipayEnabled) {
            this.paymentMethod = 'alipay'
          } else if (this.paymentMethod === 'alipay' && !this.alipayEnabled && this.wechatEnabled) {
            this.paymentMethod = 'wechat'
          } else if (!this.wechatEnabled && !this.alipayEnabled && this.balanceEnabled) {
            this.paymentMethod = 'balance'
          }
        }
      } catch (e) {
        // 加载失败时默认全部开启，不影响支付
        console.error('加载支付设置失败', e)
      }
    },
    // 加载当前账户可用余额
    async loadUserBalance () {
      try {
        const { data } = await getUserInfoDetail()
        this.userBalance = Number(data.balance) || 0
      } catch (e) {
        this.userBalance = 0
      }
    },
    async getConfirmInfo () {
      const { mode, cartIds, goodsId, goodsNum, goodsSkuId } = this.$route.query
      const { data } = await confirmOrderInfoApi({ mode, remark: this.remark, goodsId, goodsNum, goodsSkuId, cartIds: cartIds ? cartIds.split(',') : undefined })
      this.detail = data; this.goodsList = data.goodsList || []
    },
    // 提交订单并直接发起支付（无需再跳转收银台）
    async submitOrder () {
      if (this.paying || this.paid) return
      if (!this.wechatEnabled && !this.alipayEnabled && !this.balanceEnabled) {
        Toast('当前暂无可用的支付方式，请联系客服')
        return
      }
      // 余额支付需余额足够
      if (this.paymentMethod === 'balance' && !this.balanceEnough) {
        Toast('余额不足，当前余额 ¥' + Number(this.userBalance).toFixed(2) + '，请更换支付方式')
        return
      }
      const { mode, cartIds, goodsId, goodsNum, goodsSkuId } = this.$route.query
      this.paying = true
      try {
        const { data } = await submitOrderApi({ mode, remark: this.remark, goodsId, goodsNum, goodsSkuId, cartIds: cartIds ? cartIds.split(',') : undefined })
        // 兼容驼峰 / 下划线两种返回字段，避免后端版本差异导致 orderId 为 undefined，
        // 随后 payment/submit 收到空订单号而提示「订单不存在」。
        const raw = data || {}
        const order = {
          ...raw,
          orderId: raw.orderId || raw.order_id,
          orderNo: raw.orderNo || raw.order_no || ''
        }
        if (!order.orderId && !order.orderNo) {
          Toast('下单信息异常，请返回重新下单')
          return
        }
        this.$store.dispatch('cart/getCartList')
        Toast('下单成功，正在拉起支付...')
        await this.doPay(order)
      } catch (e) {
        // 错误提示已由请求拦截器统一处理
      } finally {
        this.paying = false
      }
    },
    // 根据后端返回的支付类型分发处理（支持微信 JSAPI / Native）
    async doPay (order) {
      const options = {}
      const orderId = order.orderId || order.order_id
      const orderNo = order.orderNo || order.order_no || ''
      // 微信支付：默认 JSAPI（微信内置浏览器免跳转拉起微信收银台）
      if (this.paymentMethod === 'wechat') {
        if (this.isWechat && !this.openid) {
          // 微信内未授权 → 跳转 OAuth，授权完成回跳结算台后自动拉起微信收银台
          if (!orderId) {
            Toast('订单信息异常，请返回重新下单')
            return
          }
          Toast('正在获取微信授权...')
          window.location.href = `/api/payment/oauth?orderId=${orderId}&auto_pay=1&from=pay`
          return
        }
        if (!this.isWechat) {
          Toast('请在微信内置浏览器中完成微信支付')
        }
        options.openid = this.openid
        options.tradeType = 'jsapi'
      }

      options.orderNo = orderNo
      const { data } = await payOrderApi(orderId, this.paymentMethod, options)

      // 0. 余额支付：直接支付成功
      if (data.pay_type === 'balance') {
        Toast.success('余额支付成功')
        this.loadUserBalance()
        this.finishPay()
        return
      }

      // 1. 沙箱模式：直接支付成功
      if (data.pay_type === 'sandbox') {
        Toast.success('支付成功')
        this.finishPay()
        return
      }

      // 2. 支付宝：跳转到支付宝收银台
      if (data.pay_type === 'alipay') {
        Toast('正在跳转支付宝收银台...')
        window.location.href = data.pay_url
        return
      }

      // 3. 微信 JSAPI：调用微信内置收银台
      if (data.pay_type === 'wechat_jsapi') {
        Toast('正在拉起微信支付...')
        try {
          await this.invokeWechatJsapi(data.jsapi_params)
          // JSAPI 回调 get_brand_wcpay_request:ok 即微信已确认支付成功，直接刷新订单状态并跳转订单列表
          this.paid = true
          Toast.success('支付成功')
          this.confirmPaidAndRedirect(orderId, orderNo)
        } catch (err) {
          if (err.message === '已取消支付') {
            // 取消支付：启动轮询兜底（个别场景微信可能实际已扣款但回调为 cancel）
            Toast('已取消支付')
            this.startPayPolling(orderId, orderNo)
          } else {
            Toast(err.message || '微信支付失败')
            // 拉起超时/失败时用户可能已实际扣款，启动轮询兜底确认，避免订单已支付但页面无反应
            this.startPayPolling(orderId, orderNo)
          }
        }
        return
      }

      // 4. 微信 H5：暂未启用（默认使用 JSAPI）
      if (data.pay_type === 'wechat_h5') {
        Toast('当前环境不支持 JSAPI，暂未启用 H5 支付')
        return
      }

      // 5. 微信 Native：展示支付二维码，等待扫码
      if (data.pay_type === 'wechat_native') {
        this.qrCodeDataUrl = await QRCode.toDataURL(data.code_url, {
          width: 240,
          margin: 4
        })
        this.qrVisible = true
        this.startPayPolling(orderId, orderNo)
        return
      }

      Toast('未知支付类型')
    },
    // 调用微信 JSAPI 支付（getBrandWCPayRequest）
    invokeWechatJsapi (jsapiParams) {
      return new Promise((resolve, reject) => {
        let settled = false
        let invoked = false
        let timer = null
        const cleanup = () => {
          if (timer) { clearInterval(timer); timer = null }
          document.removeEventListener('WeixinJSBridgeReady', doInvoke)
        }
        const doInvoke = () => {
          if (settled || invoked || !window.WeixinJSBridge) return
          invoked = true
          window.WeixinJSBridge.invoke('getBrandWCPayRequest', jsapiParams, (res) => {
            if (settled) return
            settled = true
            cleanup()
            const msg = (res && res.err_msg) || ''
            if (msg === 'get_brand_wcpay_request:ok') {
              resolve()
            } else if (msg === 'get_brand_wcpay_request:cancel') {
              reject(new Error('已取消支付'))
            } else {
              reject(new Error(msg || '微信支付失败'))
            }
          })
        }
        // 优先事件监听；同时轮询兜底（部分微信版本不会触发 ready 事件，但 bridge 已就绪）
        document.addEventListener('WeixinJSBridgeReady', doInvoke, false)
        timer = setInterval(() => {
          if (window.WeixinJSBridge) doInvoke()
        }, 200)
        // 10 秒超时兜底
        setTimeout(() => {
          if (settled) return
          settled = true
          cleanup()
          // 超时提示附带 appId，便于确认当前公众号与拉起支付的公众号是否一致
          const suffix = jsapiParams && jsapiParams.appId ? '（appId:' + jsapiParams.appId + '）' : ''
          reject(new Error((window.WeixinJSBridge ? '拉起微信支付超时，请重试' : '当前微信环境暂不支持拉起支付') + suffix))
        }, 10000)
        // bridge 已就绪时立即拉起
        if (window.WeixinJSBridge) doInvoke()
      })
    },
    // 轮询支付结果（微信扫码等需要等待用户完成支付）
    // 本页面仅微信支付会进入该轮询（Native 扫码 / JSAPI 取消或拉起失败兜底），
    // 因此始终带 queryWechat=true：微信侧若已扣款但异步通知未到，也会主动查单纠正订单状态
    startPayPolling (orderId, orderNo = '') {
      this.stopPayPolling()
      this.payPollTimer = setInterval(async () => {
        try {
          const { data } = await getPaymentResultApi(orderId, true, orderNo)
          // 支付后若本地订单状态尚未更新，用 paid 字段兜底判断
          if (data.paid || data.status === 1) {
            this.stopPayPolling()
            this.qrVisible = false
            Toast.success('支付成功')
            this.finishPay()
          }
        } catch (e) {
          // 单次查询失败不中断轮询
        }
      }, 3000)
    },
    stopPayPolling () {
      if (this.payPollTimer) {
        clearInterval(this.payPollTimer)
        this.payPollTimer = null
      }
    },
    closeQr () {
      this.qrVisible = false
    },
    // JSAPI 支付成功后：短暂等待微信异步通知（notify）更新订单状态，再跳转订单列表，
    // 避免跳转后订单仍显示「待支付」。最多等约 6 秒，超时也跳转（订单列表可下拉刷新）。
    async confirmPaidAndRedirect (orderId, orderNo = '') {
      // 微信已确认支付成功：主动向微信查单 / 轮询确认订单更新为待发货，最长等待约 18 秒，
      // 降低「微信已扣款成功但本地订单仍显示待支付」（notify 延迟/丢失）的概率
      for (let i = 0; i < 12; i++) {
        try {
          // queryWechat=true：订单仍待支付时主动向微信订单查询接口确认（notify 丢失兜底）
          // 支付后若本地订单状态尚未更新，用 paid 字段兜底判断
          const { data } = await getPaymentResultApi(orderId, true, orderNo)
          if (data.paid || data.status === 1) break
        } catch (e) {
          // 单次查询失败忽略，继续等待
        }
        await new Promise(resolve => setTimeout(resolve, 1500))
      }
      this.finishPay()
    },
    // 支付完成：跳转「全部订单」
    // 说明：异步通知可能比页面跳转稍晚，落到「待发货」会短暂显示空列表；
    //       跳「全部订单」可立即看到刚支付的订单，支付成功提示由查询结果页 Toast 给出。
    finishPay () {
      this.stopPayPolling()
      this.$router.replace('/myorder')
    }
  }
}
</script>

<style lang="less" scoped>
.pay { padding-top: 46px; padding-bottom: 46px;
  /deep/ .van-nav-bar__arrow { color: #333; }
  /deep/ .van-nav-bar__text { color: #333; }
  .address { display: flex; align-items: center; padding: 20px; font-size: 14px; color: #666; position: relative; background: #fff;
    .left-icon { margin-right: 20px; .van-icon { font-size: 28px; color: #ff6b35; } }
    .info { flex: 1;
      .info-content { display: flex; .name { font-size: 16px; font-weight: 700; color: #333; margin-right: 10px; } .mobile { color: #666; } }
      .info-address { margin-top: 5px; color: #999; font-size: 13px; }
    }
    .right-icon { position: absolute; right: 20px; top: 50%; transform: translateY(-7px); }
  }
  .pay-list { margin-top: 10px; background-color: #fff;
    .goods-item { height: 100px; margin-bottom: 6px; padding: 10px; background: #fff; display: flex;
      .left { width: 100px; img { display: block; width: 80px; margin: 10px auto; } }
      .right { flex: 1; font-size: 14px; line-height: 1.3; padding: 10px 10px 10px 0; display: flex; flex-direction: column; justify-content: space-evenly; color: #333;
        .spec-text { font-size: 12px; color: #999; background: #f7f8fa; display: inline-block; padding: 1px 6px; border-radius: 4px; align-self: flex-start; margin-top: 3px; }
        .info { margin-top: 5px; display: flex; justify-content: space-between; .price { color: #ff6b35; } }
      }
    }
    .flow-num-box { display: flex; justify-content: flex-end; padding: 10px; font-size: 14px; border-bottom: 1px solid #efefef; .money { color: #ff6b35; } }
  }
  .pay-cell { font-size: 14px; padding: 10px 12px; color: #333; display: flex; justify-content: space-between; .red { color: #ff6b35; } .muted { color: #999; font-size: 12px; } }
  .pay-detail, .pay-way { border-bottom: 1px solid #efefef; background: #fff; }
  .pay-way { font-size: 14px; padding: 10px 12px; color: #333; .tit { line-height: 30px; } .pay-cell { padding: 10px 0; cursor: pointer; border-radius: 6px; transition: background 0.2s; &.selected { background: #f7f8fa; padding-left: 8px; padding-right: 8px; } } .van-icon { font-size: 20px; margin-right: 5px; }
    .method-left { display: flex; align-items: center; }
    .pay-none-tip { font-size: 13px; color: #999; padding: 12px 0 6px; text-align: center; }
    .method-icon {
      display: inline-flex; align-items: center; justify-content: center;
      width: 24px; height: 24px; border-radius: 6px; color: #fff; font-size: 14px; font-weight: 700;
      margin-right: 10px;
      &.wechat { background: #07c160; }
      &.alipay { background: #1677ff; }
      &.balance { background: #ffb400; }
    }
    .balance-tip { font-size: 12px; color: #999; margin-left: 6px; &.insufficient { color: #e74c3c; } }
  }
  .pay-modal { padding: 24px 20px 30px; text-align: center;
    .modal-title { font-size: 17px; font-weight: 700; color: #1a1a2e; margin-bottom: 20px; }
    .modal-amount { display: flex; justify-content: center; align-items: baseline; gap: 8px; margin-bottom: 18px;
      .label { font-size: 14px; color: #666; }
      .price { font-size: 32px; font-weight: 700; color: #ff6b35; }
    }
    .modal-method { display: inline-flex; align-items: center; gap: 8px; background: #f7f8fa; padding: 8px 16px; border-radius: 20px; margin-bottom: 14px;
      .method-icon { display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border-radius: 50%; color: #fff; font-size: 13px; font-weight: 700; }
      .method-name { font-size: 14px; color: #333; font-weight: 600; }
    }
    .modal-order-no { font-size: 12px; color: #999; margin-bottom: 20px; }
    .modal-pay-btn { width: 100%; height: 46px; border: none; border-radius: 10px; color: #fff; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s;
      &:disabled { opacity: 0.6; }
      &:active { transform: scale(0.98); }
    }
    .modal-tip { margin-top: 12px; font-size: 12px; color: #aaa; }
  }
  // 微信 Native 扫码支付弹窗
  .qr-mask {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;

    .qr-box {
      width: 300px;
      background: #fff;
      border-radius: 16px;
      padding: 24px 20px;
      text-align: center;

      .qr-title { font-size: 17px; font-weight: 700; color: #1a1a2e; margin-bottom: 18px; }
      .qr-img { width: 240px; height: 240px; border-radius: 8px; background: #f7f8fa; border: 1px solid #f0f0f0; }
      .qr-tip { font-size: 13px; color: #666; margin-top: 14px; }
      .qr-amount { font-size: 24px; font-weight: 700; color: #ff6b35; margin: 6px 0 18px; }
      .qr-close {
        display: inline-block;
        padding: 8px 30px;
        border-radius: 20px;
        font-size: 13px;
        color: #999;
        background: #f2f3f5;
        cursor: pointer;
      }
    }
  }
  .buytips { display: block; background: #fff; textarea { display: block; width: 100%; border: none; font-size: 14px; padding: 12px; height: 100px; background: #fff; resize: none; } }
  .footer-fixed { position: fixed; background: #fff; left: 0; bottom: 0; width: 100%; height: 46px; line-height: 46px; border-top: 1px solid #efefef; font-size: 14px; display: flex;
    .left { flex: 1; padding-left: 12px; color: #666; span { color: #ff6b35; } }
    .tipsbtn { width: 121px; background: linear-gradient(90deg, #ff6b35, #ff8c42); color: #fff; text-align: center; line-height: 46px; display: block; font-size: 14px; &.disabled { opacity: 0.6; } }
  }
}
</style>
